import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetDropdown() {
    return useQuery(
        [
            URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_OPERACAO,
            URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_REFERENCIA,
            `${URL.OCUPACOES.OBTER}?Exibir=true`,
        ],
        async () => {
            const endpoints: { name: string; url: any }[] = [
                { name: "operacoesList", url: URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_OPERACAO },
                { name: "referenciasList", url: URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_REFERENCIA },
                { name: "ocupacoesList", url: `${URL.OCUPACOES.OBTER}?Exibir=true&Size=10000` },
            ];

            const requests = endpoints.map(({ name, url }) => {
                return http.get(url).then((res) => ({
                    name,
                    data: res.data || [],
                }));
            });

            const responses = await Promise.all(requests);

            const result = responses.reduce((acc, { name, data }) => {
                acc[name] = data;
                return acc;
            }, {} as Record<string, any[]>);

            return result;
        },
        {
            keepPreviousData: true,
        }
    );
}

export default useGetDropdown;
